import { ChangeEvent, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Checkbox, Group } from "@mantine/core";
import { RichText } from "src/graphql/generated/graphql";

import { FormItem } from "../FormItem";
import { RichTextEditor } from "../RichTextEditor";

export interface ConfigCustomEditorProps {
    config: string;
    onConfigChange(config: string);
}

export const ConfigCustomEditor = ({ config: configJson, onConfigChange }: ConfigCustomEditorProps) => {
    const { t } = useTranslation(["common"]);

    const config = useMemo(() => {
        if (/^\{.*\}$/.test(configJson)) {
            return JSON.parse(configJson);
        }

        return null;
    }, [configJson]);

    const handleConfirmSubmissionChange = useCallback(
        (event: ChangeEvent<HTMLInputElement>) => {
            onConfigChange?.(
                JSON.stringify({
                    ...(config || {}),
                    confirmSubmission: event?.target?.checked,
                })
            );
        },
        [onConfigChange, config]
    );

    const handleRequireContentChange = useCallback(
        (event: ChangeEvent<HTMLInputElement>) => {
            onConfigChange?.(
                JSON.stringify({
                    ...(config || {}),
                    requireContent: event?.target?.checked,
                })
            );
        },
        [onConfigChange, config]
    );

    const handleInstructionsChange = useCallback(
        (instructions: RichText) => {
            onConfigChange?.(
                JSON.stringify({
                    ...(config || {}),
                    instructions,
                })
            );
        },
        [onConfigChange, config]
    );

    return (
        <>
            <Group mb="xs">
                <Checkbox
                    color="dark"
                    label={t("campaign_productreviewdestination_custom_confirmsubmission")}
                    checked={config?.confirmSubmission}
                    onChange={handleConfirmSubmissionChange}
                />
                <Checkbox
                    color="dark"
                    label={t("campaign_productreviewdestination_custom_requirecontent")}
                    checked={config?.requireContent}
                    onChange={handleRequireContentChange}
                />
            </Group>
            <FormItem label={t("campaign_productreviewdestination_custom_instructions")}>
                <RichTextEditor value={config?.instructions} onChange={handleInstructionsChange} />
            </FormItem>
        </>
    );
};
